module.exports = __webpack_public_path__ + "static/media/3.27d298b9.jpg";